import { ItemChoiceType } from "./itemChoiceType";
import { ServiceMessageMethod } from "./ServiceMessageMethod";
import { ReceiverLookupInfo } from "./ReceiverLookupInfo";
import { BillerLookupInfo } from "./BillerLookupInfo";

export class ConsumerRegistration {
    public consumerLoginId?: string;
    public item?: string;
    public itemElementName?: ItemChoiceType | string;
    public serviceMessageMethod?: ServiceMessageMethod | null;
    public receiverInfo?: ReceiverLookupInfo[];
    public billerInfo?: BillerLookupInfo[];

    // Preferred payload shape (override keys for API)
    public consumerLoginID?: string;
    public consumerPIN?: string;
  
    // C# had a computed property: ServiceMessageMethodSpecified
    // In TypeScript, we can implement it as a getter
    public get serviceMessageMethodSpecified(): boolean {
      return this.serviceMessageMethod !== null && this.serviceMessageMethod !== undefined;
    }
  }
  